var map = {
	"./how-01-ascent-controls-identify-controls-assess-risk.png": 5198,
	"./how-02-ascent-controls-walkthrough-processes.png": 8562,
	"./how-03-ascent-controls-test-track.png": 4362,
	"./how-04-ascent-controls-report-results-status.png": 534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3814;